import type { IconData } from '@stacksjs/iconify-core'

export const browserWebsite1Solid: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M8.136 45.956c3.271.266 8.463.544 15.864.544s12.593-.278 15.864-.544c3.288-.267 5.825-2.804 6.092-6.092c.266-3.271.544-8.463.544-15.864c0-3.71-.07-6.864-.173-9.5H1.673A244 244 0 0 0 1.5 24c0 7.401.278 12.593.544 15.864c.267 3.288 2.804 5.825 6.092 6.092\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M1.815 11.5q.11-1.933.229-3.364c.267-3.288 2.804-5.825 6.092-6.092C11.407 1.778 16.599 1.5 24 1.5s12.593.278 15.864.544c3.288.267 5.825 2.804 6.092 6.092q.118 1.43.229 3.364zM7.5 7A1.5 1.5 0 0 1 9 5.5h2a1.5 1.5 0 0 1 0 3H9A1.5 1.5 0 0 1 7.5 7M17 5.5a1.5 1.5 0 0 0 0 3h2a1.5 1.5 0 0 0 0-3z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default browserWebsite1Solid
